/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconParentheses = createReactComponent("outline", "parentheses", "IconParentheses", [["path", { "d": "M7 4a12.25 12.25 0 0 0 0 16", "key": "svg-0" }], ["path", { "d": "M17 4a12.25 12.25 0 0 1 0 16", "key": "svg-1" }]]);

export { IconParentheses as default };
//# sourceMappingURL=IconParentheses.mjs.map
